import { render, staticRenderFns } from "./CreateOrActivateAccount.vue?vue&type=template&id=03522536&scoped=true"
import script from "./CreateOrActivateAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateOrActivateAccount.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CreateOrActivateAccount.vue?vue&type=style&index=0&id=03522536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03522536",
  null
  
)

export default component.exports